import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import {
    Divider,
    Modal,
    Spin,
    TimePicker,
    Tooltip,
    message,
    Button as AntButton,
    Row,
    Typography,
    Table,
    Card,
    Col,
    Tag,
    Collapse,
    Select,
    DatePicker,
    Progress,
    Form,
} from 'antd'
import {
    EditOutlined,
    CloseSquareOutlined,
    CheckSquareOutlined,
    SearchOutlined,
    PlusCircleOutlined,
    DeleteOutlined,
    CalendarOutlined,
    ClockCircleOutlined,
} from '@ant-design/icons'

// redux
import { reportsActions } from './redux/slice'
import { editTimeWithTask, timesheetApi } from './redux/apis'

// components
import ReportDocument from './reportDocument'

import dayjs from 'dayjs'
import Button from '../../../components/button/button'
import { projectReportsState } from '../projectReports/projectReports.slice'
import { pdf, PDFDownloadLink, PDFViewer } from '@react-pdf/renderer'
import WorkReportFlatTable from '../../../components/WorkReportFlatTable/WorkReportFlatTable'
import { formatMilliseconds } from '../../../utils/commonUtils'
import AddUserLog from './addUserLog'

import _ from 'lodash' // Optional: lodash helps with grouping
import { BackIconReport } from '../../../assets/icons/backIconReport'
import { saveReports, uploadRepoertS3, uploadReportS3Url } from '../../finalReports/store/finalReports.services'
import { loginState } from '../../login/login.slice'
import { updateReport } from '../../projectReport/store/projectReportService'

const EditReport = ({
    isEditReport,
    setIsEditReport,
    setShowWorkReport,
    reportId,
}) => {
    const { Title, Text } = Typography
    const { userProfile } = useSelector(loginState)
    const dispatch = useDispatch()
    const { isLoading } = useSelector((state) => state.reportTimesheet)
    const pdfDataInRedux = useSelector((state) => state.reportTimesheet)
    const pdfData = pdfDataInRedux?.pdfData
    const projectData = pdfDataInRedux?.pdfSelectedData
    const [totalHours, setTotalHours] = useState(0)
    const [isGeneratePdf, setIsGeneratePdf] = useState(false)
    const [isLoadDataGeneratePdf, setLoadDataGeneratePdf] = useState(false)
    const [editedTimeLogs, setEditedTimeLogs] = useState({})
    const [openKeys, setOpenKeys] = useState([])
    const [fromPlusClick, setFromPlusClick] = useState(false)
    const [rowErrors, setRowErrors] = useState({})
    const [taskErrors, setTaskErrors] = useState({})
    const [activeKeys, setActiveKeys] = useState([])
    const [saveLoading, setSaveLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    useEffect(() => {
        if (editedTimeLogs?.tableBody?.length > 0) {
            let hours = editedTimeLogs?.tableBody.map(
                (data) =>
                    data?.list?.length > 0 &&
                    data?.list.reduce(function (acc, obj) {
                        return acc + obj?.totalLog
                    }, 0)
            )
            const sum = hours.reduce((partialSum, a) => partialSum + a, 0)
            setTotalHours(sum)
            setIsGeneratePdf(false)
        }
    }, [editedTimeLogs?.tableBody])

    const handleGeneratePDF = () => {
        setLoadDataGeneratePdf(true)
        setTimeout(() => {
            setLoadDataGeneratePdf(false)
            setIsGeneratePdf(true)
        }, 1500)
    }

    function hourMinuteSecond(timeInMilliseconds, type) {
        let h, m, s
        h = Math.floor(timeInMilliseconds / 1000 / 60 / 60)
        m = Math.floor((timeInMilliseconds / 1000 / 60 / 60 - h) * 60)
        s = Math.floor(
            ((timeInMilliseconds / 1000 / 60 / 60 - h) * 60 - m) * 60
        )

        if (type === 'edit') {
            return `${h}:${m}:${s}s`
        } else {
            return `${h}h ${m}m ${s}s`
        }
    }
    useEffect(() => {
        setEditedTimeLogs(pdfData)
    }, [pdfData])

    const handleAddDateEntry = (assigneeId) => {
        const today = dayjs().format('YYYY-MM-DD')

        setEditedTimeLogs((prev) => {
            const updatedBody = prev.tableBody.map((user) => {
                if (user._id.assigneeId == assigneeId) {
                    const newLogEntry = {
                        list: [],
                        totalLog: 0,
                        isManualAdd: true,
                        _id: Date.now().toString(),
                        timelogList: [],
                        _id: {
                            assigneeId: assigneeId,
                            startLogDate: null,
                            taskId: Date.now().toString(),
                        },
                    }

                    return {
                        ...user,
                        list: [...user.list, newLogEntry],
                    }
                }
                return user
            })

            return {
                ...prev,
                tableBody: updatedBody,
            }
        })
    }
    // const handleSetLogDate = (assigneeId, uniqId, dateString) => {
    //     setEditedTimeLogs((prev) => {
    //         const updatedTable = prev.tableBody.map((user) => {
    //             if (user._id.assigneeId === assigneeId) {
    //                 // Prevent duplicate date for same user (excluding current entry)
    //                 const isDuplicate = user.list.some(
    //                     (entry) =>
    //                         entry._id !== uniqId &&
    //                         entry._id?.startLogDate === dateString
    //                 )

    //                 if (isDuplicate) {
    //                     message.warning(
    //                         'Selected date already exists for this user.'
    //                     )
    //                     return user
    //                 }

    //                 const updatedList = user.list.map((entry) => {
    //                     if (entry._id === uniqId) {
    //                         return {
    //                             ...entry,
    //                             _id: {
    //                                 ...entry._id,
    //                                 startLogDate: dateString,
    //                             },
    //                         }
    //                     }
    //                     return entry
    //                 })

    //                 return {
    //                     ...user,
    //                     list: updatedList,
    //                 }
    //             }
    //             return user
    //         })

    //         return {
    //             ...prev,
    //             tableBody: updatedTable,
    //         }
    //     })
    // }

    const handleSavereports = async (action, url) => {
        if (action === "save") setSaveLoading(true);
        if (action === "download") setDownloadLoading(true);
        try {
            const payload = {
                userId: userProfile._id,
                reportName: `${projectData?.project?.name
                    ? projectData?.project?.name + '-Reports'
                    : 'Reports'
                    }-${dayjs(projectData?.start).format('DD-MM-YYYY')} to ${dayjs(
                        projectData?.end
                    ).format('DD-MM-YYYY')}.pdf`,
                start: projectData?.start,
                end: projectData?.end,
                assigneeId: projectData?.assignees.map((e) => e.value),
                projectId: projectData?.project?.id,
                reportData: JSON.stringify(editedTimeLogs),
                reportUrl: url
            }
            const data = await saveReports(payload)
            if (data?.data?.success) {
                if (action === "save") setSaveLoading(false);
                if (action === "download") setDownloadLoading(false);
            }
        } catch (error) {
            if (action === "save") setSaveLoading(false);
            if (action === "download") setDownloadLoading(false);
        }
    }

    const handleUpdateports = async (action, url) => {
        try {
            const payload = {
                userId: userProfile._id,
                reportName: `${projectData?.project?.name
                    ? projectData?.project?.name + '-Reports'
                    : 'Reports'
                    }-${dayjs(projectData?.start).format('DD-MM-YYYY')} to ${dayjs(
                        projectData?.end
                    ).format('DD-MM-YYYY')}.pdf`,
                start: projectData?.start,
                end: projectData?.end,
                assigneeId: projectData?.assignees.map((e) => e.value),
                projectId: projectData?.project?.id,
                reportData: JSON.stringify(editedTimeLogs),
                reportUrl: url
            }
            const data = await updateReport(reportId, payload)
            if (data?.data?.success) {
                if (action === "save") setSaveLoading(false);
                if (action === "download") setDownloadLoading(false);
            }
        } catch (error) {
            if (action === "save") setSaveLoading(false);
            if (action === "download") setDownloadLoading(false);
        }
    }

    const handleSetLogDate = (assigneeId, uniqId, dateString) => {
        setEditedTimeLogs((prev) => {
            const updatedTable = prev.tableBody.map((user) => {
                if (user._id.assigneeId === assigneeId) {
                    // Check for duplicate date excluding current entry
                    const isDuplicate = user.list.some(
                        (entry) =>
                            entry._id !== uniqId &&
                            entry._id?.startLogDate === dateString
                    )

                    if (isDuplicate) {
                        setRowErrors((prevErrors) => ({
                            ...prevErrors,
                            [uniqId]: `An entry for ${dayjs(dateString).format(
                                'DD/MM/YYYY'
                            )} already exists for this user.`,
                        }))
                        return user
                    }

                    // ✅ Clear error if valid
                    setRowErrors((prevErrors) => ({
                        ...prevErrors,
                        [uniqId]: null,
                    }))

                    const updatedList = user.list.map((entry) => {
                        if (entry._id === uniqId) {
                            return {
                                ...entry,
                                _id: {
                                    ...entry._id,
                                    startLogDate: dateString,
                                },
                            }
                        }
                        return entry
                    })

                    return {
                        ...user,
                        list: updatedList,
                    }
                }
                return user
            })

            return {
                ...prev,
                tableBody: updatedTable,
            }
        })
    }

    const handleAddTaskEntry = (assigneeId, uniqId) => {
        setEditedTimeLogs((prev) => {
            const updatedTable = prev.tableBody.map((user) => {
                if (user._id.assigneeId === assigneeId) {
                    // copy of user.list
                    const updatedList = [...user.list]

                    // find index of entry to insert after
                    const index = updatedList.findIndex(
                        (entry) => entry._id === uniqId
                    )
                    if (index !== -1) {
                        const newTaskEntry = {
                            list: [
                                {
                                    uniqId: Date.now().toString(),
                                    title: null,
                                    type: 'Task',
                                    status: 'In Progress',
                                    estimation: 0,
                                    taskTotalLog: 0,
                                    _id: Date.now().toString(),
                                    addManualTask: true,
                                    startLogDate: Date.now().toString(),
                                    timelogs: {
                                        start: 150,
                                        end: 10,
                                        _id: Date.now().toString(),
                                        userId: assigneeId,
                                    },
                                },
                            ],
                            totalLog: 0,
                            timelogList: [],
                            _id: {
                                assigneeId: assigneeId,
                                startLogDate:
                                    updatedList[index]._id.startLogDate,
                                taskId: null,
                            },
                        }

                        // insert after matched entry
                        updatedList.splice(index + 1, 0, newTaskEntry)
                    }

                    return {
                        ...user,
                        list: updatedList,
                    }
                }
                return user
            })

            return {
                ...prev,
                tableBody: updatedTable,
            }
        })
    }

    const handleDeleteUserEntry = (assigneeId) => {
        setEditedTimeLogs((prev) => {
            const updatedTable = prev.tableBody.filter(
                (user) => user._id.assigneeId !== assigneeId
            )
            return {
                ...prev,
                tableBody: updatedTable,
            }
        })
    }


    const handleUploadReportS3 = async (file, mode = 'download') => {
        if (mode === "save") setSaveLoading(true);
        if (mode === "download") setDownloadLoading(true);

        try {
            const payload = {
                data: [
                    {
                        filename: file.file.name,
                        contentType: file.file.type,
                    },
                ],
            };

            const { data } = await uploadRepoertS3(payload);

            if (data.success) {
                await uploadFileS3Url(
                    file.file,
                    data.data[0].uploadUrl,
                    data.data[0].publicLink,
                    file.file.name,
                    mode
                );

                if (mode === "save") setSaveLoading(false);
                if (mode === "download") setDownloadLoading(false);
            }
        } catch (error) {
            if (mode === "save") setSaveLoading(false);
            if (mode === "download") setDownloadLoading(false);
            console.log("🚀 ~ handleUploadReportS3 ~ error:", error);
        }
    };

    const uploadFileS3Url = async (file, uploadUrl, publicUrl, fileName, mode) => {
        try {
            const data = await uploadReportS3Url(file, uploadUrl);

            if (data.status === 200) {
                if (reportId) {
                    await handleUpdateports(mode, publicUrl, fileName);
                } else {
                    await handleSavereports(mode, publicUrl, fileName);
                }
            }
        } catch (error) {
            console.log("🚀 ~ uploadFileS3Url ~ error:", error);
        }
    };


    // const groupedEditedLogs = useMemo(() => {
    //     if (!editedTimeLogs?.tableBody) return null;

    //     return {
    //         ...editedTimeLogs,
    //         tableBody: editedTimeLogs.tableBody.map((user) => {
    //             const mergedByDate = {};

    //             user.list.forEach((entry) => {
    //                 const date = entry._id?.startLogDate;

    //                 // ✅ Step 1: assign entry.totalLog to each task in entry.list
    //                 const updatedTaskList = entry.list.map((task) => ({
    //                     ...task,
    //                     taskTotalLog: entry.totalLog || 0,
    //                 }));

    //                 if (!mergedByDate[date]) {
    //                     mergedByDate[date] = {
    //                         ...entry,
    //                         list: [...updatedTaskList],
    //                         timelogList: [...entry.timelogList],
    //                         totalLog: entry.totalLog || 0,
    //                     };
    //                 } else {
    //                     mergedByDate[date].list.push(...updatedTaskList);
    //                     mergedByDate[date].timelogList.push(...entry.timelogList);
    //                     mergedByDate[date].totalLog += entry.totalLog || 0;
    //                 }
    //             });

    //             // ✅ Step 2: merge tasks by title (optional)
    //             const mergedList = Object.values(mergedByDate).map((entry) => {
    //                 const groupedTasks = Object.values(
    //                     entry.list.reduce((acc, task) => {
    //                         const key = task.title;

    //                         if (!acc[key]) {
    //                             acc[key] = {
    //                                 ...task,
    //                                 mergedCount: 1,
    //                             };
    //                         } else {
    //                             acc[key].mergedCount += 1;

    //                             // Optional: merge estimation
    //                             if (task.estimation) {
    //                                 acc[key].estimation =
    //                                     (acc[key].estimation || 0) + task.estimation;
    //                             }

    //                             // ✅ Add up the task logs (sum per task)
    //                             acc[key].taskTotalLog =
    //                                 (acc[key].taskTotalLog || 0) + (task.taskTotalLog || 0);
    //                         }

    //                         return acc;
    //                     }, {})
    //                 );

    //                 return {
    //                     ...entry,
    //                     list: groupedTasks,
    //                 };
    //             });

    //             return {
    //                 ...user,
    //                 list: mergedList,
    //             };
    //         }),
    //     };
    // }, [editedTimeLogs]);


    // Old Code

    // const groupedEditedLogs = useMemo(() => {
    //     if (!editedTimeLogs?.tableBody) return null

    //     return {
    //         ...editedTimeLogs,
    //         tableBody: editedTimeLogs.tableBody.map((user) => {
    //             const mergedByDate = {}

    //             user?.list?.forEach((entry) => {
    //                 const date = entry._id?.startLogDate

    //                 // ✅ add taskTotalLog safely at task level
    //                 const updatedTaskList = entry?.list.map((task) => ({
    //                     ...task,
    //                     taskTotalLog: entry?.totalLog ?? 0,
    //                 }))

    //                 // ✅ calculate totalLog as sum of taskTotalLog
    //                 const entryTotalLog = updatedTaskList.reduce(
    //                     (sum, t) => sum + (t?.taskTotalLog || 0),
    //                     0
    //                 )

    //                 if (!mergedByDate[date]) {
    //                     mergedByDate[date] = {
    //                         ...entry,
    //                         list: [...updatedTaskList],
    //                         ...(entry?.timelogList?.length > 0
    //                             ? { timelogList: [...entry?.timelogList] }
    //                             : {}),
    //                         totalLog: entryTotalLog, // ✅ sum of tasks
    //                     }
    //                 } else {
    //                     mergedByDate[date]?.list.push(...updatedTaskList)
    //                     mergedByDate[date]?.timelogList.push(
    //                         ...entry?.timelogList
    //                     )
    //                     mergedByDate[date].totalLog += entryTotalLog // ✅ accumulate
    //                 }
    //             })

    //             const mergedList = Object.values(mergedByDate).map((entry) => {
    //                 const groupedTasks = Object.values(
    //                     entry.list.reduce((acc, task) => {
    //                         const key = task?._id

    //                         if (!acc[key]) {
    //                             acc[key] = {
    //                                 ...task,
    //                                 mergedCount: 1,
    //                             }
    //                         } else {
    //                             acc[key].mergedCount += 1

    //                             if (task?.estimation) {
    //                                 acc[key].estimation =
    //                                     (acc[key]?.estimation || 0) +
    //                                     task?.estimation
    //                             }

    //                             acc[key].taskTotalLog =
    //                                 (acc[key]?.taskTotalLog || 0) +
    //                                 (task?.taskTotalLog || 0)
    //                         }

    //                         return acc
    //                     }, {})
    //                 )

    //                 // ✅ recalc entry totalLog after grouping
    //                 const totalLog = groupedTasks.reduce(
    //                     (sum, t) => sum + (t?.taskTotalLog || 0),
    //                     0
    //                 )

    //                 return {
    //                     ...entry,
    //                     list: groupedTasks,
    //                     totalLog,
    //                 }
    //             })

    //             return {
    //                 ...user,
    //                 list: mergedList,
    //             }
    //         }),
    //     }
    // }, [editedTimeLogs])



    const groupedEditedLogs = useMemo(() => {
        if (!editedTimeLogs?.tableBody) return null

        return {
            ...editedTimeLogs,
            tableBody: editedTimeLogs.tableBody.map((user) => {
                const mergedByDate = {}

                user?.list?.forEach((entry) => {
                    const date = entry._id?.startLogDate

                    // ✅ add taskTotalLog safely at task level
                    const updatedTaskList = entry?.list.map((task) => ({
                        ...task,
                        taskTotalLog: entry?.totalLog ?? 0,
                    }))

                    // ✅ calculate totalLog as sum of taskTotalLog
                    const entryTotalLog = updatedTaskList.reduce(
                        (sum, t) => sum + (t?.taskTotalLog || 0),
                        0
                    )

                    if (!mergedByDate[date]) {
                        mergedByDate[date] = {
                            ...entry,
                            list: [...updatedTaskList],
                            timelogList: entry?.timelogList
                                ? [...entry.timelogList]
                                : [],
                            totalLog: entryTotalLog,
                        }
                    } else {
                        mergedByDate[date] = {
                            ...mergedByDate[date],
                            list: [...mergedByDate[date].list, ...updatedTaskList],
                            timelogList: [
                                ...(mergedByDate[date]?.timelogList || []),
                                ...(entry?.timelogList || []),
                            ],
                            totalLog: mergedByDate[date].totalLog + entryTotalLog,
                        }
                    }
                })

                const mergedList = Object.values(mergedByDate).map((entry) => {
                    const groupedTasks = Object.values(
                        entry.list.reduce((acc, task) => {
                            const key = task?._id

                            if (!acc[key]) {
                                acc[key] = {
                                    ...task,
                                    mergedCount: 1,
                                }
                            } else {
                                acc[key] = {
                                    ...acc[key],
                                    mergedCount: acc[key].mergedCount + 1,
                                    estimation:
                                        (acc[key]?.estimation || 0) +
                                        (task?.estimation || 0),
                                    taskTotalLog:
                                        (acc[key]?.taskTotalLog || 0) +
                                        (task?.taskTotalLog || 0),
                                }
                            }

                            return acc
                        }, {})
                    )

                    // ✅ recalc entry totalLog after grouping
                    const totalLog = groupedTasks.reduce(
                        (sum, t) => sum + (t?.taskTotalLog || 0),
                        0
                    )

                    return {
                        ...entry,
                        list: groupedTasks,
                        totalLog,
                    }
                })

                return {
                    ...user,
                    list: mergedList,
                }
            }),
        }
    }, [editedTimeLogs])


    const isManualstart = dayjs(projectData?.start)
    const isManualend = dayjs(projectData?.end)

    const handleDeleteDateEntry = (assigneeId, startLogDate) => {
        setEditedTimeLogs((prev) => {
            const updatedTable = prev?.tableBody
                ?.map((user) => {
                    if (user?._id?.assigneeId === assigneeId) {
                        // delete whole date entry
                        const updatedList = user?.list?.filter(
                            (entry) => entry?._id?.startLogDate !== startLogDate
                        )
                        return {
                            ...user,
                            list: updatedList,
                        }
                    }
                    return user
                })


            return {
                ...prev,
                tableBody: updatedTable,
            }
        })
    }

    return (
        <>
            <Card
                style={{
                    // height: "100vh",
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#fff',
                    marginTop: '24px',
                    borderRadius: '16px',
                }}
                bodyStyle={
                    {
                        padding: "24px 24px 0px"
                    }
                }
                headStyle={{
                    backgroundColor: '#f0f5ff', // 🔹 change to your desired color
                }}
                title={
                    <Row
                        justify="space-between"
                        align="middle"
                        gutter={[16, 16]}
                    >
                        <Col
                            flex="1"
                            style={{ display: 'flex', alignItems: 'center' }}
                        >
                            <Tooltip title="Back">
                                <button
                                    onClick={() => setShowWorkReport()}
                                    style={{
                                        background: 'transparent',
                                        borderRadius: '50%',
                                        height: '35px',
                                        width: '35px',
                                        cursor: 'pointer',
                                        border: 'none',
                                    }}
                                >
                                    <BackIconReport width={24} />
                                </button>
                            </Tooltip>
                            <Title
                                level={4}
                                style={{ margin: 0, marginLeft: '10px' }}
                            >
                                {projectData?.project?.name || 'Reports'}
                            </Title>
                        </Col>

                        <Col>
                            <Tag color="blue" style={{ fontSize: 14 }}>
                                {hourMinuteSecond(totalHours)}
                            </Tag>
                        </Col>

                        <Col>
                            <Text>
                                {dayjs(projectData?.start).format(
                                    'DD MMM YYYY'
                                )}{' '}
                                -{' '}
                                {dayjs(projectData?.end).format('DD MMM YYYY')}
                            </Text>
                        </Col>
                    </Row>
                }
            >
                {/* <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100vh',
                    background: '#fff',
                }}
            > */}
                {/* ===== HEADER ===== */}
                {/* <div style={{ padding: '18px 20px 0px' }}>
                    <Row justify="space-between" align="middle" gutter={[16, 16]}>
                        <Col flex="1">
                            <Title level={4} style={{ margin: 0 }}>
                                {projectData?.project?.name || 'Reports'}
                            </Title>
                        </Col>

                        <Col>
                            <Tag color="blue" style={{ fontSize: 14 }}>
                                {hourMinuteSecond(totalHours)}
                            </Tag>
                        </Col>

                        <Col>
                            <Text>
                                {dayjs(projectData?.start).format('DD MMM YYYY')} -{' '}
                                {dayjs(projectData?.end).format('DD MMM YYYY')}
                            </Text>
                        </Col>
                    </Row>
                    <Divider style={{ margin: '0', marginTop: '15px' }} />
                </div> */}
                <div
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        maxHeight: 'calc(100vh - 160px)',
                        scrollbarGutter: 'stable',
                        paddingRight: 0,
                    }}
                >
                    <>
                        {/* Loading State */}
                        {isLoading ? (
                            <div
                                style={{
                                    width: '100%',
                                    height: '30vh',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Spin />
                            </div>
                        ) : (
                            <>
                                {groupedEditedLogs?.tableBody?.length > 0 ? (
                                    [...groupedEditedLogs.tableBody]
                                        .sort((a, b) => {
                                            if (a.addManual && !b.addManual)
                                                return 1
                                            if (!a.addManual && b.addManual)
                                                return -1
                                            const assigneeA =
                                                projectData?.assignees?.find(
                                                    (x) =>
                                                        x.value ===
                                                        a._id?.assigneeId
                                                )
                                            const assigneeB =
                                                projectData?.assignees?.find(
                                                    (x) =>
                                                        x.value ===
                                                        b._id?.assigneeId
                                                )
                                            return (
                                                assigneeA?.label || ''
                                            ).localeCompare(
                                                assigneeB?.label || ''
                                            )
                                        })
                                        .map((item, idx) =>
                                            projectData?.assignees?.map(
                                                (assignee) =>
                                                    assignee.value ===
                                                        item._id?.assigneeId ? (
                                                        <Collapse
                                                            key={`${assignee.value}_${idx}`}
                                                            expandIconPosition="end"
                                                            ghost={false}
                                                            style={{
                                                                margin: '15px 20px 0px',
                                                                borderRadius: 10,
                                                                background:
                                                                    '#fafafa',
                                                            }}
                                                            activeKey={openKeys}
                                                            onChange={(
                                                                keys
                                                            ) => {
                                                                if (
                                                                    fromPlusClick
                                                                ) {
                                                                    // if opened by Plus button → force keep it open
                                                                    setFromPlusClick(
                                                                        false
                                                                    ) // reset
                                                                    setOpenKeys(
                                                                        Array.from(
                                                                            new Set(
                                                                                [
                                                                                    ...openKeys,
                                                                                    assignee.value,
                                                                                ]
                                                                            )
                                                                        )
                                                                    )
                                                                } else {
                                                                    // normal behavior → allow open/close
                                                                    setOpenKeys(
                                                                        keys
                                                                    )
                                                                }
                                                            }}
                                                        >
                                                            <Collapse.Panel
                                                                key={
                                                                    assignee.value
                                                                }
                                                                header={
                                                                    <Row
                                                                        justify="space-between"
                                                                        align="middle"
                                                                    >
                                                                        <Col
                                                                            style={{
                                                                                display:
                                                                                    'flex',
                                                                                alignItems:
                                                                                    'center',
                                                                            }}
                                                                        >
                                                                            <Text
                                                                                strong
                                                                                style={{
                                                                                    fontSize: 16,
                                                                                }}
                                                                            >
                                                                                {
                                                                                    assignee.label
                                                                                }
                                                                            </Text>
                                                                            <Text
                                                                                style={{
                                                                                    marginLeft:
                                                                                        '5px',
                                                                                    fontSize: 12,
                                                                                    color: '#3f3e3efa',
                                                                                }}
                                                                            >
                                                                                (
                                                                                {
                                                                                    assignee
                                                                                        ?.designation
                                                                                        ?.name
                                                                                }

                                                                                )
                                                                            </Text>
                                                                        </Col>

                                                                        <Col
                                                                            style={{
                                                                                display:
                                                                                    'flex',
                                                                                alignItems:
                                                                                    'center',
                                                                                gap: '6px',
                                                                            }}
                                                                        >
                                                                            <Tag
                                                                                color="geekblue"
                                                                                style={{
                                                                                    fontSize:
                                                                                        '13px',
                                                                                    // padding: '4px 10px',
                                                                                    borderRadius:
                                                                                        '6px',
                                                                                    border: '1px solid #adc6ff',
                                                                                    backgroundColor:
                                                                                        '#f0f5ff',
                                                                                }}
                                                                            >
                                                                                {hourMinuteSecond(
                                                                                    item?.list.reduce(
                                                                                        (
                                                                                            acc,
                                                                                            obj
                                                                                        ) =>
                                                                                            acc +
                                                                                            obj.totalLog,
                                                                                        0
                                                                                    )
                                                                                )}
                                                                            </Tag>

                                                                            <>
                                                                                <div
                                                                                    onClick={(
                                                                                        e
                                                                                    ) =>
                                                                                        e.stopPropagation()
                                                                                    }
                                                                                >
                                                                                    <Tooltip title="Add Date">
                                                                                        <AntButton
                                                                                            shape="circle"
                                                                                            icon={
                                                                                                <PlusCircleOutlined
                                                                                                    style={{
                                                                                                        color: '#595959',
                                                                                                        fontSize: 18,
                                                                                                    }}
                                                                                                />
                                                                                            }
                                                                                            onClick={(
                                                                                                e
                                                                                            ) => {
                                                                                                e.stopPropagation()
                                                                                                const emptyDate =
                                                                                                    item.list.find(
                                                                                                        (
                                                                                                            d
                                                                                                        ) =>
                                                                                                            d
                                                                                                                ._id
                                                                                                                .startLogDate ==
                                                                                                            null
                                                                                                    )
                                                                                                if (
                                                                                                    emptyDate
                                                                                                ) {
                                                                                                    setRowErrors(
                                                                                                        (
                                                                                                            prev
                                                                                                        ) => ({
                                                                                                            ...prev,
                                                                                                            [emptyDate._id]:
                                                                                                                'Please select a date first',
                                                                                                        })
                                                                                                    )
                                                                                                    return
                                                                                                }

                                                                                                handleAddDateEntry(
                                                                                                    item
                                                                                                        ._id
                                                                                                        .assigneeId
                                                                                                )

                                                                                                setFromPlusClick(
                                                                                                    true
                                                                                                )
                                                                                                setOpenKeys(
                                                                                                    (
                                                                                                        prev
                                                                                                    ) =>
                                                                                                        Array.from(
                                                                                                            new Set(
                                                                                                                [
                                                                                                                    ...prev,
                                                                                                                    assignee.value,
                                                                                                                ]
                                                                                                            )
                                                                                                        )
                                                                                                )
                                                                                            }}
                                                                                            style={{
                                                                                                background:
                                                                                                    'transparent',
                                                                                                border: 'none',
                                                                                                boxShadow:
                                                                                                    'none',
                                                                                                padding:
                                                                                                    '0px',
                                                                                            }}
                                                                                        />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                {item.addManual && (
                                                                                    <Tooltip title="Delete User">
                                                                                        <AntButton
                                                                                            shape="circle"
                                                                                            icon={
                                                                                                <DeleteOutlined
                                                                                                    style={{
                                                                                                        color: '#ff4d4f',
                                                                                                        fontSize: 18,
                                                                                                    }}
                                                                                                />
                                                                                            }
                                                                                            onClick={() =>
                                                                                                handleDeleteUserEntry(
                                                                                                    item
                                                                                                        ._id
                                                                                                        .assigneeId
                                                                                                )
                                                                                            }
                                                                                            style={{
                                                                                                background:
                                                                                                    'transparent',
                                                                                                border: 'none',
                                                                                                boxShadow:
                                                                                                    'none',
                                                                                                padding:
                                                                                                    '0px',
                                                                                            }}
                                                                                        />
                                                                                    </Tooltip>
                                                                                )}
                                                                            </>
                                                                        </Col>
                                                                    </Row>
                                                                }
                                                            >
                                                                {/* Per-date collapses */}
                                                                {item?.list
                                                                    ?.length >
                                                                    0 &&
                                                                    [
                                                                        ...item.list,
                                                                    ]
                                                                        .sort(
                                                                            (
                                                                                a,
                                                                                b
                                                                            ) => {
                                                                                // 🔹 Rule 1: manual entries come first
                                                                                if (
                                                                                    a.isManualAdd &&
                                                                                    !b.isManualAdd
                                                                                )
                                                                                    return -1
                                                                                if (
                                                                                    !a.isManualAdd &&
                                                                                    b.isManualAdd
                                                                                )
                                                                                    return 1

                                                                                // 🔹 Rule 2: if both are same (both manual or both not), sort by date
                                                                                return dayjs(
                                                                                    a
                                                                                        ?._id
                                                                                        ?.startLogDate
                                                                                ).isAfter(
                                                                                    dayjs(
                                                                                        b
                                                                                            ?._id
                                                                                            ?.startLogDate
                                                                                    )
                                                                                )
                                                                                    ? 1
                                                                                    : -1
                                                                            }
                                                                        )
                                                                        .map(
                                                                            (
                                                                                row,
                                                                                rowIdx
                                                                            ) => (
                                                                                <Collapse
                                                                                    key={
                                                                                        rowIdx
                                                                                    }
                                                                                    activeKey={activeKeys}
                                                                                    onChange={(keys) => setActiveKeys(keys)}
                                                                                    ghost
                                                                                    defaultActiveKey={item.list.map(
                                                                                        (
                                                                                            _,
                                                                                            i
                                                                                        ) =>
                                                                                            i
                                                                                    )}
                                                                                    expandIconPosition="end"
                                                                                    style={{
                                                                                        marginBottom: 12,
                                                                                        background:
                                                                                            '#fff',
                                                                                        borderRadius: 8,
                                                                                        border: '1px solid #f0f0f0',
                                                                                        boxShadow:
                                                                                            '0 2px 6px rgba(0,0,0,0.04)',
                                                                                    }}
                                                                                    items={[
                                                                                        {
                                                                                            key: rowIdx,
                                                                                            label: (
                                                                                                <Row
                                                                                                    justify="space-between"
                                                                                                    align="middle"
                                                                                                    style={{
                                                                                                        width: '100%',
                                                                                                    }}
                                                                                                >
                                                                                                    {/* Left: Date or DatePicker */}
                                                                                                    <Col
                                                                                                        style={{
                                                                                                            display:
                                                                                                                'flex',
                                                                                                            alignItems:
                                                                                                                'center',
                                                                                                            gap: 8,
                                                                                                        }}
                                                                                                    >
                                                                                                        {row
                                                                                                            ?._id
                                                                                                            ?.startLogDate ? (
                                                                                                            <Text
                                                                                                                style={{
                                                                                                                    fontSize: 14,
                                                                                                                    fontWeight: 500,
                                                                                                                }}
                                                                                                            >
                                                                                                                {dayjs(
                                                                                                                    row
                                                                                                                        ._id
                                                                                                                        .startLogDate
                                                                                                                ).format(
                                                                                                                    'ddd, DD MMM YYYY'
                                                                                                                )}
                                                                                                            </Text>
                                                                                                        ) : (
                                                                                                            <div
                                                                                                                onClick={(
                                                                                                                    e
                                                                                                                ) =>
                                                                                                                    e.stopPropagation()
                                                                                                                }
                                                                                                            >
                                                                                                                {/* <DatePicker
                                                                                                            placeholder="Select date"
                                                                                                            format="YYYY-MM-DD"
                                                                                                            onChange={(date, dateString) =>
                                                                                                                handleSetLogDate(assignee.value, row._id, dateString)
                                                                                                            }
                                                                                                            style={{ width: 150 }}
                                                                                                            disabledDate={(current) =>
                                                                                                                current && (current < isManualstart || current > isManualend)
                                                                                                            }
                                                                                                        /> */}
                                                                                                                <Form.Item
                                                                                                                    validateStatus={
                                                                                                                        !row
                                                                                                                            ?._id
                                                                                                                            ?.startLogDate &&
                                                                                                                            rowErrors[
                                                                                                                            row
                                                                                                                                ._id
                                                                                                                            ]
                                                                                                                            ? 'error'
                                                                                                                            : ''
                                                                                                                    }
                                                                                                                    help={
                                                                                                                        rowErrors[
                                                                                                                        row
                                                                                                                            ._id
                                                                                                                        ] ||
                                                                                                                        ''
                                                                                                                    }
                                                                                                                    style={{
                                                                                                                        marginBottom: 0,
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <DatePicker
                                                                                                                        placeholder="Select date"
                                                                                                                        format="YYYY-MM-DD"
                                                                                                                        onChange={(
                                                                                                                            date,
                                                                                                                            dateString
                                                                                                                        ) =>
                                                                                                                            handleSetLogDate(
                                                                                                                                assignee.value,
                                                                                                                                row._id,
                                                                                                                                dateString
                                                                                                                            )
                                                                                                                        }
                                                                                                                        style={{
                                                                                                                            width: 150,
                                                                                                                        }}
                                                                                                                        disabledDate={(
                                                                                                                            current
                                                                                                                        ) =>
                                                                                                                            current &&
                                                                                                                            (current <
                                                                                                                                isManualstart ||
                                                                                                                                current >
                                                                                                                                isManualend)
                                                                                                                        }
                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </Col>

                                                                                                    {/* Right: Time + Actions */}
                                                                                                    <Col
                                                                                                        style={{
                                                                                                            display:
                                                                                                                'flex',
                                                                                                            alignItems:
                                                                                                                'center',
                                                                                                            gap: 12,
                                                                                                        }}
                                                                                                    >
                                                                                                        {/* Hours worked tag */}
                                                                                                        <Tag
                                                                                                            color="geekblue"
                                                                                                            style={{
                                                                                                                border: '1px solid #adc6ff',
                                                                                                                backgroundColor:
                                                                                                                    '#f0f5ff',
                                                                                                                fontSize:
                                                                                                                    '13px',
                                                                                                                padding:
                                                                                                                    '3px 12px',
                                                                                                                borderRadius:
                                                                                                                    '6px',
                                                                                                                fontWeight: 500,
                                                                                                            }}
                                                                                                        >
                                                                                                            {hourMinuteSecond(
                                                                                                                row?.totalLog
                                                                                                            )}
                                                                                                        </Tag>

                                                                                                        {/* Progress toward 8h */}
                                                                                                        {/* <Progress
                                                                                                percent={Math.min((row?.totalLog / (8 * 3600)) * 100, 100)}
                                                                                                size="small"
                                                                                                style={{ width: 80 }}
                                                                                                status={row?.totalLog >= 8 * 3600 ? 'success' : 'active'}
                                                                                            /> */}

                                                                                                        {/* Add/Delete Icons */}
                                                                                                        <div
                                                                                                            onClick={(
                                                                                                                e
                                                                                                            ) =>
                                                                                                                e.stopPropagation()
                                                                                                            }
                                                                                                            style={{
                                                                                                                display:
                                                                                                                    'flex',
                                                                                                                gap: 6,
                                                                                                            }}
                                                                                                        >
                                                                                                            <>
                                                                                                                <Tooltip title="Add Task">
                                                                                                                    <AntButton
                                                                                                                        shape="circle"
                                                                                                                        icon={
                                                                                                                            <PlusCircleOutlined
                                                                                                                                style={{
                                                                                                                                    color: '#595959',
                                                                                                                                    fontSize: 18,
                                                                                                                                }}
                                                                                                                            />
                                                                                                                        }
                                                                                                                        onClick={() => {

                                                                                                                            if (!activeKeys.includes(rowIdx)) {
                                                                                                                                setActiveKeys([...activeKeys, rowIdx]);
                                                                                                                            }
                                                                                                                            if (
                                                                                                                                !row
                                                                                                                                    ?._id
                                                                                                                                    ?.startLogDate
                                                                                                                            ) {
                                                                                                                                setRowErrors(
                                                                                                                                    (
                                                                                                                                        prev
                                                                                                                                    ) => ({
                                                                                                                                        ...prev,
                                                                                                                                        [row._id]:
                                                                                                                                            'Please select a date first',
                                                                                                                                    })
                                                                                                                                )
                                                                                                                                return
                                                                                                                            }

                                                                                                                            // 2. Prevent adding multiple empty tasks
                                                                                                                            const emptyTask =
                                                                                                                                row?.list?.find(
                                                                                                                                    (
                                                                                                                                        t
                                                                                                                                    ) =>
                                                                                                                                        !t?.title ||
                                                                                                                                        t?.title.trim() ===
                                                                                                                                        ''
                                                                                                                                )
                                                                                                                            if (
                                                                                                                                emptyTask
                                                                                                                            ) {
                                                                                                                                setTaskErrors(
                                                                                                                                    (
                                                                                                                                        prev
                                                                                                                                    ) => ({
                                                                                                                                        ...prev,
                                                                                                                                        [emptyTask._id]:
                                                                                                                                            'Please select a task before adding another',
                                                                                                                                    })
                                                                                                                                )
                                                                                                                                return
                                                                                                                            }

                                                                                                                            // ✅ Clear error if success
                                                                                                                            setRowErrors(
                                                                                                                                (
                                                                                                                                    prev
                                                                                                                                ) => ({
                                                                                                                                    ...prev,
                                                                                                                                    [row._id]:
                                                                                                                                        null,
                                                                                                                                })
                                                                                                                            )
                                                                                                                            // setTaskErrors((prev) => ({ ...prev, [row._id]: {} }))
                                                                                                                            // ✅ Add new task
                                                                                                                            handleAddTaskEntry(
                                                                                                                                assignee.value,
                                                                                                                                row._id
                                                                                                                            )
                                                                                                                        }}
                                                                                                                        style={{
                                                                                                                            background:
                                                                                                                                'transparent',
                                                                                                                            border: 'none',
                                                                                                                            boxShadow:
                                                                                                                                'none',
                                                                                                                            padding:
                                                                                                                                '0px',
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </Tooltip>

                                                                                                                {row.isManualAdd && (
                                                                                                                    <Tooltip title="Delete Date">
                                                                                                                        <AntButton
                                                                                                                            shape="circle"
                                                                                                                            icon={
                                                                                                                                <DeleteOutlined
                                                                                                                                    style={{
                                                                                                                                        color: '#ff4d4f',
                                                                                                                                        fontSize: 18,
                                                                                                                                    }}
                                                                                                                                />
                                                                                                                            }
                                                                                                                            onClick={() => {
                                                                                                                                handleDeleteDateEntry(
                                                                                                                                    assignee.value,
                                                                                                                                    row?._id?.startLogDate
                                                                                                                                )
                                                                                                                                setRowErrors(
                                                                                                                                    (
                                                                                                                                        prev
                                                                                                                                    ) => ({
                                                                                                                                        ...prev,
                                                                                                                                        [row._id]:
                                                                                                                                            null,
                                                                                                                                    })
                                                                                                                                )
                                                                                                                            }}
                                                                                                                            style={{
                                                                                                                                background:
                                                                                                                                    'transparent',
                                                                                                                                border: 'none',
                                                                                                                                boxShadow:
                                                                                                                                    'none',
                                                                                                                                padding:
                                                                                                                                    '0px',
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </Tooltip>
                                                                                                                )}
                                                                                                            </>
                                                                                                        </div>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            ),
                                                                                            children:
                                                                                                (
                                                                                                    <WorkReportFlatTable
                                                                                                        tableBody={
                                                                                                            row ||
                                                                                                            []
                                                                                                        }
                                                                                                        editedTimeLogs={
                                                                                                            editedTimeLogs
                                                                                                        }
                                                                                                        setEditedTimeLogs={
                                                                                                            setEditedTimeLogs
                                                                                                        }
                                                                                                        totalTime={
                                                                                                            row?.totalLog
                                                                                                        }
                                                                                                        setTaskErrors={
                                                                                                            setTaskErrors
                                                                                                        }
                                                                                                        taskErrors={
                                                                                                            taskErrors
                                                                                                        }
                                                                                                    />
                                                                                                ),
                                                                                        },
                                                                                    ]}
                                                                                />
                                                                            )
                                                                        )}
                                                            </Collapse.Panel>
                                                        </Collapse>
                                                    ) : null
                                            )
                                        )
                                ) : (
                                    <Text style={{ padding: '5px 20px' }}>
                                        No data available
                                    </Text>
                                )}
                                <Col>
                                    <AddUserLog
                                        editedTimeLogs={editedTimeLogs}
                                        setEditedTimeLogs={setEditedTimeLogs}
                                    />
                                </Col>
                            </>
                        )}
                    </>
                    {/* ===== FOOTER ===== */}
                    {!isLoading && (
                        <div
                            style={{
                                borderTop: '1px solid #f0f0f0',
                                padding: '10px 20px 18px',
                                textAlign: 'right',
                            }}
                        >
                            <Row justify="end">
                                <Col>
                                    <Button
                                        props={{
                                            text: 'Cancel',
                                            onClick: () => {
                                                // setIsEditReport(false)
                                                setShowWorkReport()
                                                // dispatch(
                                                //     reportsActions.downloadPdfData({
                                                //         pdfData: null,
                                                //         pdfSelectedData: null,
                                                //     })
                                                // )
                                            },
                                            style: {
                                                color: '#555',
                                                background: 'transparent',
                                                marginRight: '10px',
                                            },
                                        }}
                                    />

                                    <Button
                                        props={{
                                            text: 'Save Report',
                                            loadingButton: saveLoading,
                                            onClick: async () => {
                                                try {
                                                    setSaveLoading(true);

                                                    // 1️⃣ Generate PDF blob (without download)
                                                    const blob = await pdf(
                                                        <ReportDocument
                                                            pdfData={editedTimeLogs}
                                                            selectPdfData={projectData}
                                                        />
                                                    ).toBlob();

                                                    // 2️⃣ Convert blob to File
                                                    const fileName = `${projectData?.project?.name
                                                        ? projectData.project.name + '-Reports'
                                                        : 'Reports'
                                                        }-${dayjs(projectData?.start).format('DD-MM-YYYY')} to ${dayjs(
                                                            projectData?.end
                                                        ).format('DD-MM-YYYY')}.pdf`;

                                                    const file = new File([blob], fileName, { type: 'application/pdf' });

                                                    // 3️⃣ Upload file to S3 / API
                                                    await handleUploadReportS3({ file }, 'save');

                                                    // 4️⃣ Call save or update function
                                                    // reportId
                                                    //   ? await handleUpdateports("save", fileName)
                                                    //   : await handleSavereports("save", fileName);

                                                    message.success("Report saved successfully!");
                                                } catch (err) {
                                                    console.error("Error saving report:", err);
                                                    message.error("Failed to save report");
                                                } finally {
                                                    setSaveLoading(false);
                                                }
                                            },
                                            style: { marginRight: "10px" },
                                        }}
                                    />


                                    {/* {groupedEditedLogs?.tableBody?.length > 0 &&
                                        (!isGeneratePdf ? (
                                            <PDFDownloadLink
                                                document={
                                                    <ReportDocument
                                                        pdfData={editedTimeLogs}
                                                        selectPdfData={
                                                            projectData
                                                        }
                                                    />
                                                }
                                                fileName={`${projectData?.project?.name
                                                    ? projectData?.project
                                                        ?.name +
                                                    '-Reports'
                                                    : 'Reports'
                                                    }-${dayjs(
                                                        projectData?.start
                                                    ).format(
                                                        'DD-MM-YYYY'
                                                    )} to ${dayjs(
                                                        projectData?.end
                                                    ).format('DD-MM-YYYY')}.pdf`}
                                                style={{
                                                    textDecoration: 'none',
                                                }}
                                            >
                                                <Button
                                                    props={{
                                                        text: 'Save & Download Report',
                                                        loadingButton:
                                                            downloadLoading,
                                                        onClick: () => {
                                                            reportId
                                                                ? handleUpdateports("download")
                                                                : handleSavereports("download")
                                                        },
                                                    }}
                                                />
                                            </PDFDownloadLink>
                                        ) : (
                                            <Button
                                                props={{
                                                    text: 'Generate PDF',
                                                    loadingButton:
                                                        isLoadDataGeneratePdf,
                                                    disabled:
                                                        isLoadDataGeneratePdf,
                                                    onClick: handleGeneratePDF,
                                                }}
                                            />
                                        ))} */}
                                    {groupedEditedLogs?.tableBody?.length > 0 && (
                                        !isGeneratePdf ? (
                                            <Button
                                                props={{
                                                    text: 'Save & Download Report',
                                                    loadingButton: downloadLoading,
                                                    onClick: async () => {
                                                        try {
                                                            setDownloadLoading(true);
                                                            // 1️⃣ Generate PDF blob
                                                            const blob = await pdf(
                                                                <ReportDocument
                                                                    pdfData={editedTimeLogs}
                                                                    selectPdfData={projectData}
                                                                />
                                                            ).toBlob();

                                                            // 2️⃣ Convert blob to File for your upload function
                                                            const fileName = `${projectData?.project?.name
                                                                ? projectData.project.name + '-Reports'
                                                                : 'Reports'
                                                                }-${dayjs(projectData?.start).format('DD-MM-YYYY')} to ${dayjs(
                                                                    projectData?.end
                                                                ).format('DD-MM-YYYY')}.pdf`;

                                                            const file = new File([blob], fileName, { type: 'application/pdf' });

                                                            // 3️⃣ Trigger browser download
                                                            const link = document.createElement('a');
                                                            link.href = URL.createObjectURL(file);
                                                            link.download = fileName;
                                                            link.click();
                                                            URL.revokeObjectURL(link.href);

                                                            // 4️⃣ Upload to S3 / API
                                                            await handleUploadReportS3({ file }, 'download');

                                                            // 5️⃣ Call existing save/update report functions


                                                        } catch (err) {
                                                            console.error('Error generating/uploading PDF:', err);
                                                        } finally {
                                                            setDownloadLoading(false);
                                                        }
                                                    },
                                                }}
                                            />
                                        ) : (
                                            <Button
                                                props={{
                                                    text: 'Generate PDF',
                                                    loadingButton: isLoadDataGeneratePdf,
                                                    disabled: isLoadDataGeneratePdf,
                                                    onClick: handleGeneratePDF,
                                                }}
                                            />
                                        )
                                    )}

                                </Col>
                            </Row>
                        </div>
                    )}
                </div>
                {/* </div> */}
            </Card>
        </>
    )
}

export default EditReport
